export enum CacheEnum {
    ANALYTICS = "ANALYTICS",
    BILLING_SETTINGS = "BILLING_SETTINGS",
    BILLING_PRODUCTS_CARDS = "BILLING_PRODUCTS_CARDS",
    BILLING_INVOICE_CONSUMPTION = "BILLING_INVOICE_CONSUMPTION",
    BILLING_CARDS_COUNT = "BILLING_CARDS_COUNT",
    BILLING_INVOICES = "BILLING_INVOICES",
    NOTIFICATIONS = "NOTIFICATIONS",
    NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT",
    EXPENSES = "EXPENSES",
    VENDORS = "VENDORS",
    VENDORS_LIST = "VENDORS_LIST",
    VENDORS_MANY = "VENDORS_MANY",
    VENDORS_DROPDOWN = "VENDORS_DROPDOWN",
}

export const GENERAL_QUERY_STALE_TIME = 1 * 60 * 60 * 1000 // 1 hour in ms
export const GENERAL_QUERY_CACHE_TIME = 1 * 60 * 60 * 1000 // 1 hour in ms

export const VENDOR_DROPDOWN_FIELDS = "_id,name,isApproved,creditorNumber,img,deleted,dateDeleted"
